import { BrowserRouter} from "react-router-dom"; 
import './App.css';
import FrontPanel from "./Components/FrontPanel/FrontPanel";
import './imgUrl';


//got to frontpanel for axios default root route

function App() {
  return (
    <BrowserRouter>
      <FrontPanel />
    </BrowserRouter>
  );
}

export default App;
